import Cookies from "js-cookie";
import React from "react";
import { isRole } from "../utils/AccessManagement";
import { DrawRolesEnum } from "../utils/constants";
import {
  isAdvanceDraw,
  hasInspectionReportDocument
} from "./advanceDrawUtils";

export const getUsername = () => {
  const firstName = Cookies.get("firstName");
  const lastName = Cookies.get("lastName");
  return `${firstName} ${lastName}`;
};

const parseDrawHistoryDate = (date: any) => {
  if (!date) return null;
  const valueDTDate = String(date).replace("T", " ").replace("Z", "");
  const valueDTDateM = valueDTDate ? valueDTDate.slice(0, -7) : "";
  const valueDTDateZoneVal1 = valueDTDate
    ? `${valueDTDateM.replace(/ /g, "T")}Z`
    : "";
  const createdDate = new Date(valueDTDateZoneVal1);
  const dateArray = createdDate.toString().split(" ", 8);
  if (dateArray.length <= 2) return null;
  return dateArray;
};

export const formatAuditTrailTimestamp = (date: any) => {
  const dateArray = parseDrawHistoryDate(date);
  if (!dateArray) return null;
  return {
    dateLine: `${dateArray[2]} ${dateArray[1]} ${dateArray[3]}`,
    timeLine: dateArray[4]
  };
};

export const getDrawDateCreated = (date: any) => {
  const dateArray = parseDrawHistoryDate(date);
  return (
    dateArray && (
      <>
        {dateArray[2]} {dateArray[1]} {dateArray[3]} &bull; {dateArray[4]}
      </>
    )
  );
};

export const sanitizeStringToNum = (abc: string) => {
  try {
    if (typeof abc !== "string") return abc;
    const num = abc?.replace(/,/g, "");
    return Number(num);
  } catch (e) {
    console.error(e);
    return abc;
  }
};

export const isAMTView = () =>
  isRole(DrawRolesEnum.DRAW_MEMBER) || isRole(DrawRolesEnum.DRAW_MANAGER);
export const isOnlyDrawMember = () =>
  isRole(DrawRolesEnum.DRAW_MEMBER) && !isRole(DrawRolesEnum.DRAW_MANAGER);

export const getRoles = (): DrawRolesEnum => {
  let role: DrawRolesEnum;
  if (isAMTView()) {
    if (isOnlyDrawMember()) {
      role = DrawRolesEnum.DRAW_MEMBER;
    } else {
      role = DrawRolesEnum.DRAW_MANAGER;
    }
  } else {
    if (isRole(DrawRolesEnum.ORIGINATOR_DRAW)) {
      role = DrawRolesEnum.ORIGINATOR_DRAW;
    } else {
      role = DrawRolesEnum.ORIGINATOR_VIEW_DRAW;
    }
  }
  return role;
};

export const getAuditTrailDisplayName = (
  updatedBy?: string | null,
  stageName?: string | null
) => {
  const name = updatedBy?.trim();
  if (name) {
    return name;
  }
  if (stageName?.trim().toLowerCase() === "draw submitted") {
    return "System";
  }
  return "Unknown";
};

export const getInitials = (name?: string | null) => {
  const trimmed = name?.trim();
  if (!trimmed) {
    return "?";
  }
  const namesArray = trimmed.toUpperCase().split(/\s+/).filter(Boolean);
  if (namesArray.length >= 2) {
    return (
      namesArray[0].charAt(0) + namesArray[namesArray.length - 1].charAt(0)
    );
  }
  if (trimmed.length >= 2) {
    return trimmed.substring(0, 2).toUpperCase();
  }
  return trimmed.charAt(0).toUpperCase();
};

export const drawSubmittedDate = (drawStageHistory: any, drawStage: any) => {
  const tempObj = JSON.parse(JSON.stringify(drawStageHistory));
  const obj = tempObj.find((o: any) => o.stageName === drawStage);
  return obj?.updatedTimeStamp;
};

export function validateBoxURL(url: string): boolean {
  const regex =
    /^(https:\/\/(?:toorakcapital\.box\.com|toorakcapital\.app\.box\.com)\/(?:folder|file)\/\d+)/;
  return regex.test(url);
}

const INSPECTION_REVIEW_COMPLETE_STATUSES = new Set(["Completed", "Approved", "Approved Conditionally"]);

export function shouldShowTaggingReconcileWarning({
  drawType,
  documentTaggingStatus,
  inspectionReviewStatus,
  inspectionDocs = [],
  requireBothIncomplete = false
}: {
  drawType?: string;
  documentTaggingStatus?: string;
  inspectionReviewStatus?: string;
  inspectionDocs?: any[];
  requireBothIncomplete?: boolean;
}): boolean {
  // Advance-only: do not treat itemWise the same for tagging/reconcile warnings
  if (isAdvanceDraw(drawType) && !hasInspectionReportDocument(inspectionDocs)) {
    return false;
  }

  const taggingIncomplete = documentTaggingStatus !== "Completed";
  const inspectionIncomplete = !INSPECTION_REVIEW_COMPLETE_STATUSES.has(
    inspectionReviewStatus ?? ""
  );

  return requireBothIncomplete
    ? taggingIncomplete && inspectionIncomplete
    : taggingIncomplete || inspectionIncomplete;
}
